import { faClose, faCheck, faCopy, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import InfoIcon from "./InfoIcon"
import { Fragment, useReducer } from "react"
import useVariable from "../hook/useVariable"



export default function Modal(props) {

    const { header, body, footer, onClose,hideCopy } = props

    const { variableType, variableValue } = useVariable()
    let bodyContent = variableType(body) === 'object' && variableValue(body.props) ? variableValue(body.props.children) : body

    const modalReducer = (state, action) => {
        switch (action.type) {

            case 'COPY':
                return { ...state, copy: !state.copy }
            case 'COPY_FAILED':
                return { ...state, copy: !state.copy, copyIcon: faTriangleExclamation }
            default:
                return state
        }
    }

    const [reducerState, reducerDispatch] = useReducer(modalReducer, {
        copyIcon: faCheck,
        copy: false
    })


    return <div className="modal-container rso-pages react shadow">

        <div className="modal-header">

            <div className="header-content" >

                {header}

            </div>
           {!hideCopy && 
           
            <span className="copy-icon" style={{ position: 'absolute', right: 30, cursor: 'copy' }} >
                {reducerState.copy ?

                    <Fragment>
                        <InfoIcon reverse={true} withBubble={true} icon={reducerState.copyIcon} title={reducerState.copyIcon === faCheck ? 'copied in clipboard' : 'page is not secure to copy in clipboard'} size="lg" />

                    </Fragment>
                    :
                    <Fragment>
                        <InfoIcon reverse={true} delay={3000} withBubble={true} icon={faCopy} title="copy json" size="lg" onClick={(event) => {

                            let isSecure = window.isSecureContext
                            if (isSecure) {
                                let jsonOutput = bodyContent
                                navigator.clipboard.writeText(jsonOutput)
                                reducerDispatch({ type: 'COPY' })
                                setTimeout(() => {
                                    reducerDispatch({ type: 'COPY' })
                                }, 3000)

                            } else {

                                reducerDispatch({ type: 'COPY_FAILED' })
                            }


                        }} />

                    </Fragment>
                }

            </span>

           }
            <span className="modal-close-btn" > <InfoIcon icon={faClose} onClick={() => {
                onClose()
            }} /></span>


        </div>

        <div className="modal-body">
            {body}
        </div>

        <div className="modal-footer">
            {footer}
            <button type="button" className="btn btn-secondary modal-close-btn" onClick={() => {
                onClose()
            }} >Close</button>
        </div>
    </div>



}
